import styled from 'styled-components';
import { Field, Icon } from '@phishtool/ui';
export const StyledList = styled.ul.withConfig({ displayName: "StyledList", componentId: "-111ppsq" }) `
  padding: 0;
  margin: 0 0 ${(props) => props.theme.spacers.xxl};
`;
export const StyledListItem = styled.li.withConfig({ displayName: "StyledListItem", componentId: "-1m2zku3" }) `
  display: flex;
  gap: ${(props) => props.theme.spacers.small};
  margin: 0 0 ${(props) => props.theme.spacers.medium};
  font-size: 14px;
`;
export const StyledIcon = styled(Icon).withConfig({ displayName: "StyledIcon", componentId: "-1xr7v6r" }) `
  margin-top: 3px;
`;
export const StyledListItemText = styled.span.withConfig({ displayName: "StyledListItemText", componentId: "-sr4ozy" }) `
  flex: 1;
`;
export const StyledTextInput = styled(Field).withConfig({ displayName: "StyledTextInput", componentId: "-m0u2ti" }) `
  flex: 1;
`;
export const StyledTextArea = styled(Field).withConfig({ displayName: "StyledTextArea", componentId: "-1bthv0d" }) `
  max-width: none;

  textarea {
    height: 200px;
  }
`;
